const defaultState = {
  hoverState: false,
  hoverStateht: false,
  hoverStatehc: false,
  hoverStatelc: false,
  hoverStatecu: false,
  clickStateUpDownShopAll: false,
  clickStateUpDownHouseHolds: false,
  clickStateUpDownMoreHouseHolds: false,
  clickStateUpDownRealEstate: false,
  clickStateUpDownPets: false,
  clickStateUpDownSkilledLabour: false,
  modalStatus: undefined,
  shopAll : false,
  houseHold: false,
  moreHouseHold: false,
  realEstate:false,
  skilledLabour:false,
  pets: false,
  onDemand:false,
  recommended: false,
  contact: false,
  location: false,
  toggleAuthSettings:false,
  requestSearchClose:false,
  section: 'none',
  categories: {},
  waitingStatus: false,
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_HOVER':
      return {
        ...state,
        hoverState: action.hoverState,
      }
    case 'SET_HOVERHT':
      return {
        ...state,
        hoverStateht: action.hoverStateht,
      }
    case 'SET_HOVERHC':
      return {
        ...state,
        hoverStatehc: action.hoverStatehc,
      }
    case 'SET_HOVERLC':
      return {
        ...state,
        hoverStatelc: action.hoverStatelc,
      }
    case 'SET_HOVERCU':
      return {
        ...state,
        hoverStatecu: action.hoverStatecu,
      }
    case 'SET_CLICK_STATE_UP_DOWN_SHOPALL':
      return {
        ...state,
        clickStateUpDownShopAll: action.clickStateUpDownShopAll,
      }
    case 'SET_CLICK_STATE_UP_DOWN_HOUSEHOLDS':
      return {
        ...state,
        clickStateUpDownHouseHolds: action.clickStateUpDownHouseHolds,
      }
      case 'SET_CLICK_STATE_UP_DOWN_MORE_HOUSEHOLDS':
      return {
        ...state,
        clickStateUpDownMoreHouseHolds: action.clickStateUpDownMoreHouseHolds,
      }
    case 'SET_CLICK_STATE_UP_DOWN_REALESTATE':
      return {
        ...state,
        clickStateUpDownRealEstate: action.clickStateUpDownRealEstate,
      }
    case 'SET_CLICK_STATE_UP_DOWN_PETS':
      return {
        ...state,
        clickStateUpDownPets: action.clickStateUpDownPets,
      }
    case 'SET_CLICK_STATE_UP_DOWN_SKILLED_LABOUR':
      return {
        ...state,
        clickStateUpDownSkilledLabour: action.clickStateUpDownSkilledLabour,
      }
    case 'SET_MODAL_STATE':
      return {
        ...state,
        modalStatus : action.modalStatus
      }
    case 'SET_SHOP_ALL_STATE':
      return {
        ...state,
        shopAll : action.shopAll
      }
    case 'SET_HOUSEHOLD_STATE':
      return {
        ...state,
        houseHold : action.houseHold
      }
    case 'SET_MORE_HOUSEHOLD_STATE':
      return {
        ...state,
        moreHouseHold : action.moreHouseHold
      }
    case 'SET_REAL_ESTATE_STATE':
      return {
        ...state,
        realEstate : action.realEstate
      }
    case 'SET_SKILLED_LABOUR_STATE':
      return {
        ...state,
        skilledLabour : action.skilledLabour
      }
    case 'SET_PET_STATE':
      return {
        ...state,
        pet : action.pet
      }
    case 'SET_ON_DEMAND_STATE':
      return {
        ...state,
        onDemand : action.onDemand
      }
    case 'SET_RECOMMENDED_STATE':
      return {
        ...state,
        recommended : action.recommended
      }
    case 'SET_LOCATION_STATE':
      return {
        ...state,
        location : action.location
      }
    case 'SET_CONTACT_STATE':
      return {
        ...state,
        contact : action.contact
      }
    case 'SET_TOGGLE_AUTH_SETTINGS':
      return {
        ...state,
        toggleAuthSettings : action.toggleAuthSettings
      }
    case 'SET_SEARCH_SETTINGS':
      return {
        ...state,
        requestSearchClose : action.requestSearchClose
      }
    case 'SET_CATEGORIES':
      return {
        ...state,
        categories: action.categories
      }
    case 'SET_SINGLE_CATEGORY':
      return {
        ...state,
        section: action.section
      }
    case 'SET_WAITING_STATUS':
      return {
        ...state,
        waitingStatus: action.waitingStatus
      }
    default:
      return state;
  };
}
